// src/pages/CommercialTransactionPage.tsx
import React from "react";
import { Link } from "react-router-dom";
import { FiArrowLeft, FiBookOpen } from "react-icons/fi";
import { usePageTitle } from "../hooks/usePageTitle";

const CommercialTransactionPage: React.FC = () => {
	usePageTitle("特定商取引法に基づく表記");

	return (
		<div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-8">
			<div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
				{/* Header */}
				<div className="mb-8">
					<Link
						to="/"
						className="inline-flex items-center text-sm text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 mb-4"
					>
						<FiArrowLeft className="w-4 h-4 mr-1" />
						トップページに戻る
					</Link>
					<div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-200 dark:border-gray-700 p-8">
						<div className="flex items-center gap-4 mb-4">
							<div className="flex items-center justify-center w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full">
								<FiBookOpen className="w-6 h-6 text-white" />
							</div>
							<div>
								<h1 className="text-3xl font-bold text-gray-900 dark:text-white">
									特定商取引法に基づく表記
								</h1>
								<p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
									最終更新日: 2026年3月22日
								</p>
							</div>
						</div>
					</div>
				</div>

				{/* Content */}
				<div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-200 dark:border-gray-700 p-8">
					<div className="prose prose-gray dark:prose-invert max-w-none">
						<div className="overflow-x-auto">
							<table className="w-full border-collapse">
								<tbody>
									<tr className="border-b border-gray-200 dark:border-gray-700">
										<th className="text-left py-4 px-4 w-1/3 text-gray-900 dark:text-white font-semibold bg-gray-50 dark:bg-gray-700/50 align-top">
											販売事業者名
										</th>
										<td className="py-4 px-4 text-gray-700 dark:text-gray-300">
											合同会社blackadder
										</td>
									</tr>
									<tr className="border-b border-gray-200 dark:border-gray-700">
										<th className="text-left py-4 px-4 w-1/3 text-gray-900 dark:text-white font-semibold bg-gray-50 dark:bg-gray-700/50 align-top">
											代表者
										</th>
										<td className="py-4 px-4 text-gray-700 dark:text-gray-300">
											宮田浩平 / 小畑和彰（共同代表）
										</td>
									</tr>
									<tr className="border-b border-gray-200 dark:border-gray-700">
										<th className="text-left py-4 px-4 w-1/3 text-gray-900 dark:text-white font-semibold bg-gray-50 dark:bg-gray-700/50 align-top">
											所在地
										</th>
										<td className="py-4 px-4 text-gray-700 dark:text-gray-300">
											〒150-0002
											<br />
											東京都渋谷区渋谷2-19-15
											宮益坂ビルディング609
										</td>
									</tr>
									<tr className="border-b border-gray-200 dark:border-gray-700">
										<th className="text-left py-4 px-4 w-1/3 text-gray-900 dark:text-white font-semibold bg-gray-50 dark:bg-gray-700/50 align-top">
											電話番号
										</th>
										<td className="py-4 px-4 text-gray-700 dark:text-gray-300">
											請求があった場合は遅滞なく開示いたします。
											<br />
											お問い合わせ先メールアドレスまでご連絡ください。
										</td>
									</tr>
									<tr className="border-b border-gray-200 dark:border-gray-700">
										<th className="text-left py-4 px-4 w-1/3 text-gray-900 dark:text-white font-semibold bg-gray-50 dark:bg-gray-700/50 align-top">
											法人番号
										</th>
										<td className="py-4 px-4 text-gray-700 dark:text-gray-300">
											3011003019957
										</td>
									</tr>
									<tr className="border-b border-gray-200 dark:border-gray-700">
										<th className="text-left py-4 px-4 w-1/3 text-gray-900 dark:text-white font-semibold bg-gray-50 dark:bg-gray-700/50 align-top">
											設立
										</th>
										<td className="py-4 px-4 text-gray-700 dark:text-gray-300">
											2024年9月12日
										</td>
									</tr>
									<tr className="border-b border-gray-200 dark:border-gray-700">
										<th className="text-left py-4 px-4 w-1/3 text-gray-900 dark:text-white font-semibold bg-gray-50 dark:bg-gray-700/50 align-top">
											資本金
										</th>
										<td className="py-4 px-4 text-gray-700 dark:text-gray-300">
											5,000,000円
										</td>
									</tr>
									<tr className="border-b border-gray-200 dark:border-gray-700">
										<th className="text-left py-4 px-4 w-1/3 text-gray-900 dark:text-white font-semibold bg-gray-50 dark:bg-gray-700/50 align-top">
											メールアドレス
										</th>
										<td className="py-4 px-4 text-gray-700 dark:text-gray-300">
											<a
												href="mailto:info@blackadder.co.jp"
												className="text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 transition-colors"
											>
												info@blackadder.co.jp
											</a>
										</td>
									</tr>
									<tr className="border-b border-gray-200 dark:border-gray-700">
										<th className="text-left py-4 px-4 w-1/3 text-gray-900 dark:text-white font-semibold bg-gray-50 dark:bg-gray-700/50 align-top">
											サービスURL
										</th>
										<td className="py-4 px-4 text-gray-700 dark:text-gray-300">
											<a
												href="https://ticket.blackadder.co.jp"
												className="text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 transition-colors"
												target="_blank"
												rel="noopener noreferrer"
											>
												https://ticket.blackadder.co.jp
											</a>
										</td>
									</tr>
									<tr className="border-b border-gray-200 dark:border-gray-700">
										<th className="text-left py-4 px-4 w-1/3 text-gray-900 dark:text-white font-semibold bg-gray-50 dark:bg-gray-700/50 align-top">
											販売価格
										</th>
										<td className="py-4 px-4 text-gray-700 dark:text-gray-300">
											各イベントページに表示された価格に準じます。
											<br />
											表示価格は税込みです。
										</td>
									</tr>
									<tr className="border-b border-gray-200 dark:border-gray-700">
										<th className="text-left py-4 px-4 w-1/3 text-gray-900 dark:text-white font-semibold bg-gray-50 dark:bg-gray-700/50 align-top">
											販売価格以外に必要な費用
										</th>
										<td className="py-4 px-4 text-gray-700 dark:text-gray-300">
											<ul className="list-disc list-inside space-y-1">
												<li>
													チケット購入時に所定のサービス手数料が発生する場合があります（購入画面に表示されます）
												</li>
												<li>
													インターネット接続に必要な通信費用はお客様のご負担となります
												</li>
											</ul>
										</td>
									</tr>
									<tr className="border-b border-gray-200 dark:border-gray-700">
										<th className="text-left py-4 px-4 w-1/3 text-gray-900 dark:text-white font-semibold bg-gray-50 dark:bg-gray-700/50 align-top">
											支払方法
										</th>
										<td className="py-4 px-4 text-gray-700 dark:text-gray-300">
											クレジットカード決済（Visa、Mastercard、JCB、American
											Express、Diners Club）
										</td>
									</tr>
									<tr className="border-b border-gray-200 dark:border-gray-700">
										<th className="text-left py-4 px-4 w-1/3 text-gray-900 dark:text-white font-semibold bg-gray-50 dark:bg-gray-700/50 align-top">
											支払時期
										</th>
										<td className="py-4 px-4 text-gray-700 dark:text-gray-300">
											チケット購入手続き完了時に決済が行われます。
											<br />
											クレジットカードの引き落とし日は、各カード会社の規定に準じます。
										</td>
									</tr>
									<tr className="border-b border-gray-200 dark:border-gray-700">
										<th className="text-left py-4 px-4 w-1/3 text-gray-900 dark:text-white font-semibold bg-gray-50 dark:bg-gray-700/50 align-top">
											商品の引渡し時期
										</th>
										<td className="py-4 px-4 text-gray-700 dark:text-gray-300">
											決済完了後、電子チケット（QRコード）が即時発行されます。
											<br />
											マイページよりご確認いただけます。
										</td>
									</tr>
									<tr className="border-b border-gray-200 dark:border-gray-700">
										<th className="text-left py-4 px-4 w-1/3 text-gray-900 dark:text-white font-semibold bg-gray-50 dark:bg-gray-700/50 align-top">
											返品・キャンセルについて
										</th>
										<td className="py-4 px-4 text-gray-700 dark:text-gray-300">
											<p className="mb-2">
												電子チケットという商品の性質上、購入後のお客様都合によるキャンセル・返金は原則としてお受けできません。
											</p>
											<p className="mb-2">
												ただし、以下の場合は返金対応いたします。
											</p>
											<ul className="list-disc list-inside space-y-1">
												<li>
													主催者の都合によるイベントの中止・延期の場合
												</li>
												<li>
													システムの不具合により二重決済が発生した場合
												</li>
												<li>
													その他、当社が返金が相当と判断した場合
												</li>
											</ul>
											<p className="mt-2">
												詳しくは
												<Link
													to="/cancellation-policy"
													className="text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 transition-colors"
												>
													キャンセル・返金ポリシー
												</Link>
												をご確認ください。
											</p>
										</td>
									</tr>
									<tr className="border-b border-gray-200 dark:border-gray-700">
										<th className="text-left py-4 px-4 w-1/3 text-gray-900 dark:text-white font-semibold bg-gray-50 dark:bg-gray-700/50 align-top">
											動作環境
										</th>
										<td className="py-4 px-4 text-gray-700 dark:text-gray-300">
											<p className="mb-2">
												本サービスは、以下の環境でご利用いただけます。
											</p>
											<ul className="list-disc list-inside space-y-1">
												<li>
													Google Chrome（最新版）
												</li>
												<li>Safari（最新版）</li>
												<li>
													Microsoft Edge（最新版）
												</li>
												<li>
													Mozilla Firefox（最新版）
												</li>
											</ul>
											<p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
												※
												上記以外のブラウザでは正常に動作しない場合があります。
											</p>
										</td>
									</tr>
									<tr>
										<th className="text-left py-4 px-4 w-1/3 text-gray-900 dark:text-white font-semibold bg-gray-50 dark:bg-gray-700/50 align-top">
											特別な販売条件
										</th>
										<td className="py-4 px-4 text-gray-700 dark:text-gray-300">
											<ul className="list-disc list-inside space-y-1">
												<li>
													チケットの転売は禁止しております
												</li>
												<li>
													イベントにより年齢制限がある場合があります（各イベントページに記載）
												</li>
												<li>
													購入枚数に制限がある場合があります（各イベントページに記載）
												</li>
											</ul>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default CommercialTransactionPage;
